import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-styles",
  "use": "icon-styles-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-styles\">\n<path d=\"M27.6905 11H12.3095C11.3116 11 10.5 11.7689 10.5 12.7143V27.2857C10.5 28.2311 11.3116 29 12.3095 29H27.6905C28.688 29 29.5 28.2311 29.5 27.2857V12.7143C29.5 11.7689 28.688 11 27.6905 11ZM27.6905 17.8571H19.5476V12.7143H27.6905V17.8571ZM12.3095 12.7143H17.7381V27.2857H12.3095V12.7143ZM19.5476 27.2857V19.5714H27.6909L27.6914 27.2857H19.5476Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol